import { Component, ChangeDetectorRef } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ConfirmationService, Message } from "primeng/api";
import { ApiServiceService } from "src/app/api-service.service";
import { AppUtility } from "src/app/interceptor/appUtitlity";
import { Router } from "@angular/router";
import { filter } from "jszip";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: "app-tool-loan",
  templateUrl: "./tool-loan.component.html",
  styleUrls: ["./tool-loan.component.scss"],
})
export class ToolLoanComponent {
  breadcrumb = [
    {
      title: "Tool Loan Form",
      subTitle: "Dashboard",
    },
  ];
  BussinessUnitNumberTable: any = [];
  supplierList: any = [];
  showLinkInput: boolean = false;
  currencyDropdownValue: any;
  partDrawingData: any;
  showAssetNoInput: boolean = false;
  showExpenseInput: boolean = false;
  showcapitalInput: boolean = false;
  selectedPartIds: number[] = [];  // Stores selected part IDs
  partdescdata: any
  poTypeData: any;
  linedata: number;
  toolid: number;
  isadded: boolean = false
  poNotFoundError: boolean = false;
  budata: any;
  code: any = {};
  msgs: Message[] = [];
  role: any;
  constructor(
    private fb: FormBuilder,
    private _apiService: ApiServiceService,
    private _utility: AppUtility,
    private confirmationService: ConfirmationService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }
  tooltype = [
    { id: 'New', name: 'New', },
    { id: 'Shifted', name: 'Shifted', },
  ];
  ngOnInit() {

    this.getBusinessUnit();
    this.getAllSupplierDetail();
    this.getPoType();
    this.getBUdata();
    this.role = JSON.parse(localStorage.getItem("UserObject"));
    if (this.role.roleName === "Finance") {
      this.toolLoanForm.disable();
    } else {
    }

    this.toolLoanForm.get('OrderNumber')?.valueChanges.pipe(
      debounceTime(1000),
    ).subscribe(async (poNo) => {  // Make the callback function async
      this.getbyorder(poNo)

    });
    this.toolLoanForm.get('poType')?.valueChanges.subscribe(value => {
      const orderNumberControl = this.toolLoanForm.get('OrderNumber');

      if (value) {
        orderNumberControl?.enable();
      } else {
        orderNumberControl?.disable();
        orderNumberControl?.reset();
      }
    });

    this.toolLoanForm.get('bu')?.valueChanges.subscribe(value => {
      if (this.budata) {
        const selectedBu = this.budata.find((item: any) => item.value === value);
        if (selectedBu) {
          this.toolLoanForm.get('buMasterId')?.setValue(selectedBu.id);
        } else {
          this.toolLoanForm.get('buMasterId')?.setValue(null);
        }
      }
    });
  }
  /* -------------------------------------------------------------------------- */
  /*                       // get business unit master api                      */
  /* -------------------------------------------------------------------------- */
  getBusinessUnit() {
    this._utility.loader(true);
    this._apiService
      .dropdowndata("BussinessUnitNumber")
      .then((res: any) => {
        console.log(res);
        this._utility.loader(false);
        if (res.success == true) {
          this.BussinessUnitNumberTable = res.returnValue;
        } else {
          this.BussinessUnitNumberTable = [];
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.BussinessUnitNumberTable = [];
      });
  }
  /* -------------------------------------------------------------------------- */
  /*                              // supplier list                              */
  /* -------------------------------------------------------------------------- */
  getAllSupplierDetail() {
    this._utility.loader(true);
    this._apiService.getSupplier().then((res: any) => {
      console.log(res);
      this._utility.loader(false);
      if (res.success == true) {
        this.supplierList = res.returnValue;
        console.log(this.supplierList, "change");

      } else {
        this._utility.loader(false)
        this.supplierList = [];
      }
    });

    // to get currency value
    // this._apiService.dropdowndata("currency").then((res: any) => {
    //   if (res.success) {
    //     this.currencyDropdownValue = res.returnValue;
    //     console.log(this.currencyDropdownValue);
    //   } else {
    //     this.currencyDropdownValue = [];
    //   }
    // });
    //to get partDrawing data
    // this._apiService.getPartDrawing().then((res: any) => {
    //   if (res.success == true) {
    //     this.partDrawingData = res.returnValue;
    //     console.log(this.partDrawingData);
    //   } else {
    //     this.partDrawingData = [];
    //   }
    // });
  }
  //get po type dropdown data
  getPoType() {
    this._apiService.getPoType().then((res: any) => {
      if (res.success == true) {
        console.log(res);
        this.poTypeData = res.returnValue;
      } else {
        this.poTypeData = [];
        console.log("no data found in po type");
      }
    });
  }
  // get supplier data on dropdown selection
  // getSupplierData(data: any) {
  //   var supplierId = data.target.value;
  //   console.log(data.target.value);
  //   // this.locationVal = data.target.value;
  //   this.supplierList.forEach((key: any) => {
  //     if (key.supplierId == supplierId) {
  //       this.toolLoanForm.controls.location.setValue(key.city);
  //     }
  //   });
  // }
  getSupplierData(data: any) {
    var part = data.value;
    this.supplierList.forEach((key: any) => {
      if (key.supplierName == part) {
        this.toolLoanForm.controls.jdecode.setValue(key.jdeNo);
        this.toolLoanForm.controls.supplierid.setValue(key.supplierId);
      }
    });
  }
  // get draiwng no. on dropdown selection
  // getPartDrawingId(data: any) {
  //   var partId = data.target.value;
  //   //   let tool=PartDrawingId.filter(id =>{
  //   // })
  //   // const selectedToolId = data.target.value;

  //   //  const selectedTool = partDrawingId.find(tool => tool.id === selectedToolId);
  //   this.partDrawingData.forEach((key: any) => {
  //     if (key.partId == partId) {
  //       console.warn(key.partDrawingName)
  //       this.toolLoanForm.controls.toolDescription.setValue(key.PartDrawingDescription);
  //     }
  //   });
  // }


  // agreement signed or not function
  // agreementSigned(event: any) {
  //   if (event.target.value == "yes") {
  //     this.showLinkInput = true;
  //     this.toolLoanForm.controls.LinkorToolLoanAgreement.setValidators(
  //       Validators.required
  //     );
  //     this.toolLoanForm.controls.LinkorToolLoanAgreement.updateValueAndValidity();
  //   } else {
  //     this.showLinkInput = false;
  //     this.toolLoanForm.controls.LinkorToolLoanAgreement.removeValidators;
  //     this.toolLoanForm.controls.LinkorToolLoanAgreement.updateValueAndValidity();
  //   }
  // }
  // get tool type
  getToolType(event: any) {
    this.code = {};
    if (event.target.value == "capital") {
      this.showAssetNoInput = true;
      this.showExpenseInput = false;
      this.showcapitalInput = true
      // this.toolLoanForm.controls.idexAssetNo.setValue(this.code);
    } else {
      this.showAssetNoInput = false;
      this.showExpenseInput = true;
      this.showcapitalInput = false;
      // this._apiService.getAssestCode().then((code: any) => {
      //   console.log(code);
      //   this.code = code.EnquiryNumber;
      //   this.toolLoanForm.controls.idexAssetNo.setValue(this.code);
      // });
    }
  }
  /* -------------------------------------------------------------------------- */
  /*                            // form controls name                           */
  /* -------------------------------------------------------------------------- */
  toolLoanForm = this.fb.group({
    bu: new FormControl(null, [Validators.required]),
    businessUnit: new FormControl(null, [Validators.required]),
    buMasterId: new FormControl(null),
    poType: new FormControl(null, [Validators.required]),
    OrderNumber: new FormControl({ value: null, disabled: true }, [Validators.required]),
    ItemDescription: new FormControl(null, [Validators.required]),
    SupplierName: new FormControl(null, [Validators.required]),
    capital: new FormControl(null, [Validators.required]),
    remarks: new FormControl(""),
    jdecode: new FormControl(""),
    tooltype: new FormControl(""),
    ToolDetails: this.fb.array([]),
    supplierid: new FormControl(),
    ItemNumber: new FormControl(""),
    unitprice: new FormControl("")

  });

  // financeRoleForm = this.fb.group({
  //   capitalAssetNo: new FormControl('', [Validators.required]),
  // });
  customValidator(group: FormGroup) {
    // const toolLoanAgreementSigned = group.get('ToolLoanAgreementSigned').value;
    // const linkOrToolLoanAgreement = group.get('LinkorToolLoanAgreement').value;
    const capital = group.get("capital").value;
    const idexAssetNo = group.get("idexAssetNo").value;
    if (capital === "capital" && !idexAssetNo) {
      group.get("idexAssetNo").setErrors({ required: true });
    } else {
      group.get("idexAssetNo").setErrors(null);
    }
    return null;
  }

  get ToolDetails(): FormArray {
    return this.toolLoanForm.get('ToolDetails') as FormArray;
  }
  submitForm() {
    console.log(this.toolLoanForm.valid, this.toolLoanForm.value);
    if (this.toolLoanForm.valid) {
      this._utility.loader(true)
      if (this.role.roleName === "Finance") {
        console.log(this.toolLoanForm.valid, this.toolLoanForm.value);
        this.confirmationService.confirm({
          message:
            "Are you sure you want to proceed? After adding the information, there will be no option for further edits to the form.",
          header: "Confirmation",
          icon: "pi pi-info-circle",
          accept: () => {
            let formData = new FormData;
            formData.append('ToolListId', localStorage.getItem("toolId"))
            // let data = {
            //   IdexAssetNo: this.toolLoanForm.controls.capitalAssetNo.value,
            //   ToolListId: localStorage.getItem("toolId"),
            // };
            // let body = JSON.stringify(data);
            this._apiService.sendAssetNo(formData).then((res: any) => {
              if (res.success == false) {
                this._apiService.showMessage(res.message, "error");
              } else {
                this._apiService.showMessage(res.message, "success");
                this.router.navigateByUrl("/toolLoanAgreement");
              }
            });
          },
        });
      } else {
        const jsonObject = this.toolLoanForm.getRawValue();
        delete jsonObject.ItemDescription;
        const formData = JSON.stringify(jsonObject);
        this.confirmationService.confirm({
          message:
            "Are you sure you want to proceed? After adding the information, there will be no option for further edits to the form.",
          header: "Confirmation",
          icon: "pi pi-info-circle",
          accept: () => {
            this._apiService.addToolLoanAgreement(formData).then((res: any) => {
              if (res.success == false) {
                this._utility.loader(false)
                this._apiService.showMessage(res.message, "error");
              } else {
                this._utility.loader(false)
                this._apiService.showMessage(res.message, "success");
                this.router.navigateByUrl("/toolLoanAgreement");
              }

            }).catch(err => {
              this._utility.loader(false);
              this._apiService.showMessage("Something went wrong.", "error");
            });

          },
          reject: () => {
            this._utility.loader(false); // 🛑 Stop loader if user clicks 'No'
          }
        });
      }

    } else {
      this._apiService.showMessage("Please fill form details", "error");
      console.log("Form not valid");
    }

  }

  //get bu data dropdown
  getBUdata() {
    this._apiService
      .dropdowndata("BUMaster")
      .then((res: any) => {
        console.log(res);
        if (res.success == true) {
          this.budata = res.returnValue;
        } else {
          this.budata = [];
        }
      })
      .catch((error: any) => {
        this.budata = [];
      });
  }
  // getDieShift(event:any){
  //   if(event.target.value == 'yes'){
  //     this.toolLoanForm.controls.dieShift.setValue(true);
  //   }else{
  //     this.toolLoanForm.controls.dieShift.setValue(false);
  //   }
  //  console.log(event.target.value);
  // }
  async getbyorder(poNo: any) {
    const orderType = this.toolLoanForm.controls.poType.value;;
    if (poNo) {
      console.log(poNo, ":dta");
      const data = {
        orderNumber: poNo,
        orderType: orderType,
      }
      try {
        const res = await this._apiService.getpartdesById(data);  // Await the API call
        console.log(res);

        if (res?.['success']) {
          console.log(res, "data");
          this.poNotFoundError = false;
          this.cdr.detectChanges();
          this.partdescdata = res['returnValue'];
          this._apiService.showMessage('Part data retrived successfully', 'success');
          //       const itemNumbers   = this.partdescdata.map(item => item.itemNumber);
          // const unitPrices    = this.partdescdata.map(item => item.unitPrice);
          //  const supplierNames = this.partdescdata.map(item => item.supplierName);
          //   this.toolLoanForm.patchValue({
          //   ItemNumber: itemNumbers,
          //   unitprice: unitPrices,
          //   // SupplierName: supplierNames
          // });
          //       if (typeof supplierNames === 'string' && supplierNames.trim() !== '') {
          //         this.toolLoanForm.patchValue({ SupplierName: supplierNames });

          //           this.getSupplierData({ value: supplierNames });
          //       }
          //   this.toolLoanForm.patchValue({ ItemNumber: itemNumber });
          //   this.toolLoanForm.patchValue({ unitprice: unitprice });

          this.partDrawingData = this.partdescdata.map(item => ({ itemDesc: [item.itemDesc, item.itemDesc2].filter(desc => desc && desc.trim()).join(', ') }))
          this.linedata = this.partdescdata.map(item => item.lineNumber)
          this.toolid = this.partdescdata.map(item => item.id)
        }
      } catch (error: any) {
        console.error("Error fetching customer data:", error);

        // Handle 404 Not Found or explicit success: false in the error response
        if (error?.status === 404 || error?.error?.success === false) {
          this.poNotFoundError = true;
          this.cdr.detectChanges();
          this._apiService.showMessage("please choose correct po type and po number for parts", "error");
        }
      }
    }
  }
  onDescriptionSelected(event: any) {
    const selectedDescs: string[] = event.value; // <-- Array of selected descriptions
    console.log("Selected descriptions:", selectedDescs);

    // Find all matches from partdescdata
    const matchedParts = this.partdescdata.filter(item => {
      const combined = [item.itemDesc, item.itemDesc2]
        .filter(desc => desc && desc.trim())
        .join(', ')
        .trim();
      return selectedDescs.includes(combined);
    });

    console.log("Matched parts:", matchedParts);

    if (matchedParts.length > 0) {
      // Patch arrays of values instead of a single value
      this.toolLoanForm.patchValue({
        ItemNumber: matchedParts.map(p => p.itemNumber),
        unitprice: matchedParts.map(p => p.unitPrice),
        SupplierName: matchedParts[0].supplierName // assuming supplier same, else handle separately
      });

      if (matchedParts[0].supplierName) {
        this.getSupplierData({ value: matchedParts[0].supplierName });
      }
    } else {
      console.warn("No match found for:", selectedDescs);
    }
  }


  addItemObject: FormArray;
  addToGrid() {
    const selectedDescs = this.toolLoanForm.get('ItemDescription')?.value || [];
    const selectedNumbers = this.toolLoanForm.get('ItemNumber')?.value || [];
    const selectedPrices = this.toolLoanForm.get('unitprice')?.value || [];

    if (this.toolLoanForm.valid && selectedDescs.length > 0) {
      const existingPartDescs = this.ToolDetails.value.map((entry: any) => entry.ItemDescription);

      selectedDescs.forEach((desc: string, index: number) => {
        if (!existingPartDescs.includes(desc)) {
          const entry = this.fb.group({
            poType: [this.toolLoanForm.get('poType')?.value],
            OrderNumber: [this.toolLoanForm.get('OrderNumber')?.value],
            ItemDescription: [desc],
            SupplierName: [this.toolLoanForm.get('SupplierName')?.value],
            capital: [this.toolLoanForm.get('capital')?.value],
            remarks: [this.toolLoanForm.get('remarks')?.value],
            jdecode: [this.toolLoanForm.get('jdecode')?.value],
            tooltype: [this.toolLoanForm.get('tooltype')?.value],
            linenumber: [this.linedata[index]],
            JdePOId: [this.toolid[index]],
            ItemNumber: [selectedNumbers[index]],   // <-- each desc gets its own number
            unitprice: [selectedPrices[index]]      // <-- each desc gets its own price
          });

          this.ToolDetails.push(entry);
        }
      });

      this.isadded = true;
      this.toolLoanForm.disable({ emitEvent: false });
      this.toolLoanForm.get('ItemDescription')?.enable();
      this.toolLoanForm.get('capital')?.enable();

      console.log("Grid Data:", this.ToolDetails.value);
    } else {
      this._apiService.showMessage("please fill the details", "error");
    }
  }

  deleteItem(ItemDescription: string | number) {

    this.ToolDetails.controls.forEach((control, idx) => {
    });

    const index = this.ToolDetails.controls.findIndex(
      (control) => control.get('ItemDescription')?.value == ItemDescription
    );


    if (index !== -1) {
      this.ToolDetails.removeAt(index);

      this.partDrawingData = this.partDrawingData.map(item => ({
        ...item,
        disabled: item.itemDesc == ItemDescription ? false : item.disabled,
      }));

      this.partDrawingData = [...this.partDrawingData];
    } else {
      console.warn("Item not found:", ItemDescription);
    }
  }




  confirm1(index: string) {
    this.confirmationService.confirm({
      message: "Are you sure that you want to proceed?",
      header: "Delete Item Record",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.msgs = [
          {
            severity: "info",
            summary: "Confirmed",
            detail: "You have accepted",
          },
        ];
        this.deleteItem(index);
      },
      reject: () => {
        this.msgs = [
          {
            severity: "info",
            summary: "Rejected",
            detail: "You have rejected",
          },
        ];
      },
    });
  }

  resetform() {
    this.toolLoanForm.reset();
    this.partDrawingData = [];
    (this.toolLoanForm.get('ToolDetails') as FormArray).clear();
    this.toolLoanForm.enable();
    this.isadded = false;
  }
}
